<template>
  <el-dialog title="在线咨询" :visible.sync="show" width="748px" class="contractWrapper" @close="closeMe">
    <el-form :model="form" :rules="rules" ref="contractForm">
      <el-form-item label="请输入您的问题，我们将尽快安排相关人员与您联系" prop="question">
        <el-input type="textarea" v-model="form.question" :rows="4" placeholder="请输入您要咨询的问题，如：这个课程有打折政策吗？"></el-input>
      </el-form-item>
      <el-form-item label="如何联系您" prop="account">
        <el-input v-model="form.account" placeholder="请输入您的电话或者邮箱"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" class="contractBtn" @click="submitForm('contractForm')">提交咨询</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'Contract',
  props: {
    contractVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      show: false,
      form: {
        account: '',
        question: ''
      },
      rules: {
        account: [
          { required: true, message: '请输入您的联系方式', trigger: 'blur' }
        ],
        question: [
          { required: true, message: '请输入您的问题', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    contractVisible: {
      handler (nval) {
        this.show = nval
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$message({
            type: 'success',
            message: '提交成功！'
          })
          this.$emit('confirm')
          this.resetForm('contractForm')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeMe () {
      this.resetForm('contractForm')
      this.$emit('cancel')
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>
<style scoped>
.contractWrapper >>> .el-dialog{
  border-radius: 10px;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .contractWrapper{
    height: 100%;
    width: 100%;
    .forgetPass{
      float: left;
      margin: -10px 0 0 50px;
    }
    .dialog-footer{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .contractBtn{
        width: 150px;
        background-color: #BC1A33;
        border-color: #BC1A33;
        color: #fff;
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
</style>
